var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThreatMetrix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 137 35",
    style: {
      enableBackground: "new 0 0 137 35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#666666;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.2,9.6h6.9V12h-2.3v10.1h-2.4V12h-2.2V9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.1,9.3h2.3v4.5c0.5-0.4,0.9-0.7,1.4-0.9c0.5-0.2,0.9-0.3,1.4-0.3c0.9,0,1.7,0.3,2.3,1 c0.5,0.5,0.8,1.4,0.8,2.4v6.1H51v-4c0-1.1-0.1-1.8-0.2-2.2c-0.1-0.4-0.3-0.7-0.5-0.8c-0.2-0.2-0.6-0.3-0.9-0.3 c-0.5,0-0.9,0.2-1.2,0.5c-0.3,0.3-0.6,0.7-0.7,1.3c-0.1,0.3-0.1,0.9-0.1,1.9v3.7h-2.3V9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.5,12.9h2V14c0.2-0.5,0.5-0.8,0.9-1c0.4-0.2,0.7-0.4,1.2-0.4c0.3,0,0.6,0.1,0.9,0.2l-0.7,2 c-0.3-0.1-0.5-0.2-0.7-0.2c-0.4,0-0.7,0.2-0.9,0.7c-0.2,0.4-0.4,1.3-0.4,2.6l0,0.4v3.7h-2.3V12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.5,18.2H62c0.1,0.7,0.4,1.2,0.9,1.6c0.5,0.4,1.1,0.6,1.8,0.6c0.9,0,1.6-0.3,2.2-0.9l2,0.9 c-0.5,0.7-1.1,1.2-1.7,1.5c-0.7,0.3-1.5,0.5-2.4,0.5c-1.4,0-2.6-0.5-3.5-1.4c-0.9-0.9-1.4-2.1-1.4-3.4c0-1.4,0.5-2.6,1.4-3.5 c0.9-0.9,2-1.4,3.4-1.4c1.5,0,2.6,0.5,3.5,1.4c0.9,0.9,1.4,2.2,1.4,3.7L69.5,18.2z M67.1,16.4c-0.2-0.5-0.5-0.9-0.9-1.3 c-0.5-0.3-1-0.5-1.6-0.5c-0.6,0-1.2,0.2-1.7,0.5c-0.3,0.2-0.6,0.6-0.9,1.2H67.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.7,12.9H80v9.2h-2.3v-1c-0.5,0.4-0.9,0.7-1.4,0.9c-0.5,0.2-0.9,0.3-1.5,0.3c-1.2,0-2.2-0.5-3.1-1.4 c-0.9-0.9-1.3-2.1-1.3-3.5c0-1.4,0.4-2.6,1.3-3.5c0.8-0.9,1.9-1.4,3.1-1.4c0.6,0,1.1,0.1,1.6,0.3c0.5,0.2,0.9,0.5,1.3,0.9V12.9z  M75.3,14.8c-0.7,0-1.3,0.3-1.8,0.8c-0.5,0.5-0.7,1.2-0.7,1.9c0,0.8,0.2,1.5,0.7,2c0.5,0.5,1.1,0.8,1.8,0.8c0.7,0,1.3-0.3,1.8-0.8 c0.5-0.5,0.7-1.2,0.7-2c0-0.8-0.2-1.5-0.7-2C76.6,15,76,14.8,75.3,14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.2,9.5h2.3v3.4h1.4v2h-1.4v7.2h-2.3v-7.2H81v-2h1.2V9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.5,9.6h2.3l2.9,8.7l2.9-8.7h2.3l2.1,12.5h-2.3l-1.3-7.9l-2.7,7.9h-2.1L91,14.2l-1.4,7.9h-2.3L89.5,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.1,18.2h-7.4c0.1,0.7,0.4,1.2,0.9,1.6c0.5,0.4,1.1,0.6,1.8,0.6c0.9,0,1.6-0.3,2.2-0.9l2,0.9 c-0.5,0.7-1.1,1.2-1.7,1.5c-0.7,0.3-1.5,0.5-2.4,0.5c-1.4,0-2.6-0.5-3.5-1.4c-0.9-0.9-1.4-2.1-1.4-3.4c0-1.4,0.5-2.6,1.4-3.5 c0.9-0.9,2-1.4,3.4-1.4c1.5,0,2.6,0.5,3.5,1.4c0.9,0.9,1.4,2.2,1.4,3.7L112.1,18.2z M109.7,16.4c-0.2-0.5-0.5-0.9-0.9-1.3 c-0.5-0.3-1-0.5-1.6-0.5c-0.6,0-1.2,0.2-1.7,0.5c-0.3,0.2-0.6,0.6-0.9,1.2H109.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113.8,9.5h2.3v3.4h1.4v2h-1.4v7.2h-2.3v-7.2h-1.2v-2h1.2V9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.2,12.9h2V14c0.2-0.5,0.5-0.8,0.9-1c0.4-0.2,0.7-0.4,1.2-0.4c0.3,0,0.6,0.1,0.9,0.2l-0.7,2 c-0.3-0.1-0.5-0.2-0.7-0.2c-0.4,0-0.7,0.2-0.9,0.7c-0.2,0.4-0.4,1.3-0.4,2.6l0,0.4v3.7h-2.3V12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.2,9.1c0.4,0,0.8,0.1,1,0.4c0.3,0.3,0.4,0.7,0.4,1.1c0,0.4-0.1,0.8-0.4,1.1c-0.3,0.3-0.6,0.4-1,0.4 c-0.4,0-0.8-0.1-1.1-0.4s-0.4-0.7-0.4-1.1c0-0.4,0.1-0.8,0.4-1C124.4,9.2,124.8,9.1,125.2,9.1z M124,12.9h2.3v9.2H124V12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.6,12.9h2.7l1.8,2.5l1.8-2.5h2.6l-3.1,4.3l3.5,4.9h-2.7l-2.2-3l-2.2,3h-2.6l3.5-4.9L127.6,12.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.2,7.4c-0.4-0.4-1.1-0.4-1.5,0l-9.3,9.3c-0.4,0.4-0.4,1.1,0,1.5c0.4,0.4,1.1,0.4,1.5,0l9.3-9.3 C11.6,8.5,11.6,7.8,11.2,7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.5,16.1c-0.4-0.4-1.1-0.4-1.5,0L10.3,26.7c-0.4,0.4-0.4,1.1,0,1.5c0.4,0.4,1.1,0.4,1.5,0l10.6-10.6 C23,17.2,23,16.5,22.5,16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.2,6.8c-0.4-0.4-1.1-0.4-1.5,0L12.4,17.9c-0.4,0.4-0.4,1.1,0,1.5c0.4,0.4,1.1,0.4,1.5,0L25.2,8.3 C25.6,7.9,25.6,7.2,25.2,6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.8,13.5c-0.4-0.4-1.1-0.4-1.5,0l-6.8,6.8c-0.4,0.4-0.4,1.1,0,1.5c0.4,0.4,1.1,0.4,1.5,0l6.8-6.8 C32.3,14.6,32.3,13.9,31.8,13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.8,3.4c-0.4-0.4-1.1-0.4-1.5,0l-6.5,6.5c-0.4,0.4-0.4,1.1,0,1.5c0.4,0.4,1.1,0.4,1.5,0L21.8,5 C22.2,4.5,22.2,3.8,21.8,3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.2,16.8c-0.4-0.4-1.1-0.4-1.5,0L31,19.3c-0.4,0.4-0.4,1.1,0,1.5c0.4,0.4,1.1,0.4,1.5,0l2.6-2.6 C35.6,17.9,35.6,17.2,35.2,16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.5,23.6L29.5,23.6L29.5,23.6c0-0.1,0-0.1,0-0.1l0-2c0-0.6-0.5-1.1-1.1-1.1c-0.6,0-1.1,0.5-1.1,1.1l0,1.5 L17,33.4c-0.4,0.4-0.4,1.1,0,1.5c0.4,0.4,1.1,0.4,1.5,0l10.6-10.6C29.4,24.1,29.5,23.8,29.5,23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22,24.1v-1.8c0-0.6-0.5-1.1-1.1-1.1c-0.6,0-1.1,0.5-1.1,1.1l0,1.5l-6.2,6.2c-0.4,0.4-0.4,1.1,0,1.5 c0.4,0.4,1.1,0.4,1.5,0l6.5-6.5C22,24.9,22.1,24.5,22,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.3,13.8l0-1.8c0-0.6-0.5-1.1-1.1-1.1c-0.6,0-1.1,0.5-1.1,1.1l0,1.5L3.7,20c-0.4,0.4-0.4,1.1,0,1.5 c0.4,0.4,1.1,0.4,1.5,0l6.8-6.8C12.2,14.5,12.3,14.2,12.3,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.9,6.8l0-1.5l3.6-3.6c0.4-0.4,0.4-1.1,0-1.5s-1.1-0.4-1.5,0L13,4c-0.3,0.3-0.4,0.6-0.3,1l0,1.8 c0,0.6,0.5,1.1,1.1,1.1S14.9,7.4,14.9,6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.2,15.5l0-1.5l2.3-2.3c0.4-0.4,0.4-1.1,0-1.5c-0.4-0.4-1.1-0.4-1.5,0l-2.7,2.7c-0.3,0.3-0.4,0.6-0.3,1 l0,1.8c0,0.6,0.5,1.1,1.1,1.1C25.7,16.6,26.2,16.1,26.2,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11,21.8V20c0-0.6-0.5-1.1-1.1-1.1c-0.6,0-1.1,0.5-1.1,1.1v1.5L7,23.4c-0.4,0.4-0.4,1.1,0,1.5 c0.4,0.4,1.1,0.4,1.5,0l2.1-2.1C11,22.5,11.1,22.1,11,21.8z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreatMetrix);
export default __webpack_public_path__ + "static/media/threat-metrix.a59fb0e5e1a8af85ff182634ab577d4c.svg";
export { ForwardRef as ReactComponent };